/**
 * Stores sorting priorities for issue severity
 */
export enum IssueSeveritySortingEnum {
  ERROR = 0,
  WARNING = 1,
  INFO = 2
}
